const DEFAULT_NAME = '小榔铺'
const CACHE_KEY = 'custom_brand_title'

let cachedTitle = localStorage.getItem(CACHE_KEY) || ''
let observer = null
let replaceTimer = null

// 从地址栏读取 title 参数（兼容 ?title=xxx 与 hash 内的 #/xxx?title=xxx 两种形式）
function getTitleFromUrl() {
  const href = window.location.href
  const tryParse = (str) => {
    const idx = str.indexOf('?')
    if (idx === -1) return ''
    const params = new URLSearchParams(str.slice(idx + 1))
    return (params.get('title') || '').trim()
  }
  // 优先取 hash 后面的参数，再取普通 search 参数
  return tryParse(window.location.hash) || tryParse(href)
}

// 替换页面中所有「小榔铺」文字，包括浏览器标签标题
export function applyCustomTitle() {
  if (!cachedTitle) return
  document.title = document.title.replace(new RegExp(DEFAULT_NAME, 'g'), cachedTitle)
  document.body && document.body.childNodes.forEach(walkNode)
}

function walkNode(node) {
  if (node.nodeType === Node.TEXT_NODE) {
    if (node.textContent.indexOf(DEFAULT_NAME) !== -1) {
      node.textContent = node.textContent.replace(new RegExp(DEFAULT_NAME, 'g'), cachedTitle)
    }
  } else if (node.nodeType === Node.ELEMENT_NODE) {
    node.childNodes.forEach(walkNode)
  }
}

// DOM 变化后延迟替换（防抖），覆盖弹窗、异步渲染等动态内容
function scheduleReplace() {
  if (!cachedTitle) return
  clearTimeout(replaceTimer)
  replaceTimer = setTimeout(applyCustomTitle, 50)
}

function observeDom() {
  if (observer || !document.body) return
  observer = new MutationObserver(scheduleReplace)
  observer.observe(document.body, { childList: true, subtree: true, characterData: true })
}

// 应用启动时调用：地址栏带 title 则永久缓存，之后每次进入都从缓存读取并替换
export function initCustomTitle() {
  const urlTitle = getTitleFromUrl()
  if (urlTitle) {
    cachedTitle = urlTitle
    localStorage.setItem(CACHE_KEY, urlTitle)
  }
  if (cachedTitle) {
    applyCustomTitle()
    observeDom()
  }
}
